






import { defineComponent } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import App from './App.vue';
import AppLoading from './AppLoading.vue';
import AppError from './AppError.vue';
import { useRequiredAppDataStore } from './stores/required-app-data.store';

export default defineComponent({
  components: {
    App,
    AppLoading,
    AppError,
  },
  setup() {
    const requiredAppDataStore = useRequiredAppDataStore();
    const { isErrorDuringFirstLoad, error, isLoaded } = storeToRefs(useRequiredAppDataStore());

    requiredAppDataStore.load();

    return {
      isErrorDuringFirstLoad,
      error,
      isLoaded,
    };
  },
});
